import { render, staticRenderFns } from "./ProvisionalRemedyRequest.vue?vue&type=template&id=19a2fc36&scoped=true&"
import script from "./ProvisionalRemedyRequest.vue?vue&type=script&lang=js&"
export * from "./ProvisionalRemedyRequest.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionalRemedyRequest.vue?vue&type=style&index=0&id=19a2fc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2fc36",
  null
  
)

export default component.exports